import { render, staticRenderFns } from "./NoSuggestedlisting.vue?vue&type=template&id=27f4f840&scoped=true&"
import script from "./NoSuggestedlisting.vue?vue&type=script&lang=ts&"
export * from "./NoSuggestedlisting.vue?vue&type=script&lang=ts&"
import style0 from "./NoSuggestedlisting.vue?vue&type=style&index=0&id=27f4f840&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f4f840",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VImg,VTextField})
